export const Cancel = ({ ...rest }): JSX.Element => {
    return <i className="fa fas fa-times" {...rest} />;
};
